






































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Nullable from '@/types/nullable';
import VueSignaturePad from 'vue-signature-pad';
import moment from 'moment';
import { DATE_FORMAT_READABLE } from "comunet-jobs-and-technician-repository-shared/constants";

@Component({
  components: {
    VueSignaturePad
  }
})
export default class SignatureField extends Vue {
  @Prop({ type: String, default: null }) public uri!: Nullable<string>;
  @Prop({ type: String, default: null }) public signedAs!: Nullable<string>;
  @Prop({ type: String, default: null }) public signedAt!: Nullable<string>;
  @Prop({ type: Boolean, default: false }) public readonly!: boolean;
  @Prop({ type: Boolean, default: false }) public showAgreement!: boolean;
  private showSignature: boolean = false;
  private showSignatureForm: boolean = false;
  private selectedSignedAs: string = null;
  private loading: boolean = false;
  private errorMessage: string = null;

  get formattedSignedAt() {
    return moment(this.signedAt).local().format(DATE_FORMAT_READABLE);
  }

  view(){
    this.showSignature = true;
  }

  sign(){
    this.showSignatureForm = true;

    this.selectedSignedAs = null;
    this.$nextTick(() => {
      // @ts-ignore
      this.$refs.signaturePad.clearSignature();
    });
  }

  undo(){
    // @ts-ignore
    this.$refs.signaturePad.undoSignature(); 
  }

  save(){
    this.loading = true;

    let signaturePad: any = this.$refs.signaturePad;

    if(signaturePad.isEmpty()){
      this.errorMessage = "Please input a signature";
      this.loading = false;
      return;
    }

    let canvas = signaturePad.signaturePad.canvas;

    try {
      canvas.toBlob((blob: Blob) => {
        try {
          let reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = () => {
            let base64 = reader.result;

            this.$emit('onSignatureChanged', {
              base64: base64,
              contentType: 'image/png',
              fileName: 'signature.png',
              signedAs: this.selectedSignedAs,
              signedAt: moment().utc().format('YYYY-MM-DD HH:mm:ss')
            });

            this.showSignatureForm = false;
            this.loading = false;
          };
        } catch(err) {
          this.errorMessage = err.message;
          this.loading = false;
        }
      });
    } catch (err) {
      this.errorMessage = err.message;
      this.loading = false;
    }
  }
}

